import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _createCustomStrategy = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/custom-strategies`,
    payload,
    config
  )
}

const _getCustomStrategies = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/custom-strategies?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/custom-strategies`


  return Request.get(
    url,
    config
  )
}

const _deleteCustomStrategy = strategyId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/custom-strategies/${strategyId}`, config)
}

const _getCustomStrategy = strategyId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/custom-strategies/${strategyId}`, config)
}


const _updateCustomStrategy = (strategy) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/custom-strategies/${strategy._id}`, strategy, config)
}

const _getCategoriesMapping = (projectId) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/custom-strategies/${projectId}/category-mapping`, config)
}

const _previewRelatedProducts = (payload) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/custom-strategies/related-products/preview`, payload, config)
}

// Probador de recomendaciones: ejecuta una estrategia en discover sin registrar impresiones.
const _runRecoTest = (payload) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(`${window.config.VUE_APP_BACKEND}/api/reco-tester/run`, payload, config)
}

// Generar/refinar reglas de productos relacionados con IA: el run es asíncrono
// (cola en admin-apis); el editor consulta su estado cada pocos segundos.
const strategyAiRequest = (method, path, payload) => {
  const config = { headers: { authorization: `Bearer ${getUserToken()}` } }
  const url = `${window.config.VUE_APP_BACKEND}/api/strategy-ai-runs${path}`
  return method === 'get' ? Request.get(url, config) : Request.post(url, payload || {}, config)
}

export default {
  getStrategyAiConfig: () => strategyAiRequest('get', '/config'),
  createStrategyAiRun: (payload) => strategyAiRequest('post', '', payload),
  getStrategyAiRun: (id) => strategyAiRequest('get', `/${id}`),
  listStrategyAiRuns: (query) => strategyAiRequest('get', `?${new URLSearchParams(query).toString()}`),
  cancelStrategyAiRun: (id) => strategyAiRequest('post', `/${id}/cancel`),
  applyStrategyAiRun: (id) => strategyAiRequest('post', `/${id}/apply`),
  dismissStrategyAiRun: (id) => strategyAiRequest('post', `/${id}/dismiss`),
  updateCustomStrategy: _updateCustomStrategy,
  deleteCustomStrategy : _deleteCustomStrategy, 
  getCustomStrategies : _getCustomStrategies,
  createCustomStrategy : _createCustomStrategy,
  getCustomStrategy: _getCustomStrategy,
  getCategoriesMapping: _getCategoriesMapping,
  previewRelatedProducts: _previewRelatedProducts,
  runRecoTest: _runRecoTest
}
